import React, { useState } from "react";
import Modal from 'react-awesome-modal';
import {Button} from 'reactstrap';
// import correct from '../../assets/img/icons/correct.gif'
// import Modal from 'react-modal';
import good from '../../assets/img/icons/good.gif'
import warn from '../../assets/img/icons/warn.png'
import ques from '../../assets/img/icons/ques.gif'

export const SuccessModal = ({isModalOpen,closeModal, message, status}) => {
	
	return(
		<Modal 
			visible={isModalOpen} 
			effect="fadeInUp" 
			onClickAway={() =>closeModal()}
			// style={{maxWidth:'40%', minWidth:'350px'}}
			width="400" 
			height="300"
		>
        	<div className="d-flex flex-column justify-content-center align-items-center mt-2">
            	<img src={status !== null && status === false ? warn : good} width="30%"/>

            	{status !== null && status === false ? <h1 >Failed!</h1> : <h1 >Success!</h1>}
            	
            	<h5 className="mb-4">{message ? message : "Operation processed successfully"}</h5>
            	<Button color="primary" size="lg" onClick={() => closeModal()}>OK</Button>
        	</div>
    	</Modal>
		)
}

export const FailModal = ({isModalOpen,closeModal, message, status}) => {
	
	return(
		<Modal 
			visible={isModalOpen} 
			effect="fadeInUp" 
			onClickAway={() =>closeModal()}
			// style={{maxWidth:'40%', minWidth:'350px'}}
			width="400" 
			height="300"
		>
        	<div className="d-flex flex-column justify-content-center align-items-center mt-2">
            	<img src={warn} width="30%"/>

            	<h1 >{status ? "Rejected!" : "Failed!"}</h1>
            	
            	<h5 className="mb-4">{message ? message : "Operation processed successfully"}</h5>
            	<Button color="primary" size="lg" onClick={() => closeModal()}>OK</Button>
        	</div>
    	</Modal>
		)
}


export const ConfirmModal = ({isModalOpen,closeModal, message, deleteCompany}) => {
	return(
		<Modal visible={isModalOpen} width="400" height="300" effect="fadeInUp" onClickAway={() =>closeModal()}>
        	<div className="d-flex flex-column justify-content-center align-items-center">
            	<img src={ques} width="150px"/>

            	<h3 className="text-center">{message}</h3 >
            	<div style={{
            		    width: "100%",
    					position: "absolute",
    					bottom: "10px",
    					display: "flex",
    					flexDirection: "row",
    					justifyContent: "space-evenly",
    					alignItems: "center",
            	}}>
            		<Button color="primary" size="md" onClick={() => deleteCompany()}>Yes</Button>
            		<Button color="secondary" size="md" onClick={() => closeModal()}>Cancel</Button>
            	</div>
        	</div>
    	</Modal>
		)
}


